<template>
    <div class="screenWidth itemList pt-4">
        <!-- 麵包屑 -->
        <BreadCrumbs :breadCrumbList="breadCrumbList"
                     :gaData="gaData" />
        <!-- 切換顯示樣式 -->
        <div class="mb-md-3 mb-lg-0 pt-md-3 pt-md-0 row no-gutters">
            <div class="col-12">
                <Theme :titleText="categories"
                       :font24="true" />
            </div>
            <div class="col-12 d-block d-md-flex justify-content-md-end">
                <label class="text-nowrap mt-2 mt-md-1 mb-1 mb-md-0 flex flex-md-grow-1 d-block text-right text-md-left">
                    共有 {{total|commaFormat}}項結果
                </label>
                <!-- 切換顯示樣式 -->
                <div class="text-right listType mb-3">
                    <button type="button"
                            class="btn btn-link py-0 border-right rounded-0"
                            @click="setDisplay('card')">
                        <GridIcon v-if="display === 'card'"
                                  size="1.5x"
                                  stroke-width="2" />
                        <GridIcon v-else
                                  size="1.5x"
                                  stroke-width="2"
                                  class="lightcolor" />
                    </button>
                    <button type="button"
                            class="btn btn-link py-0 rounded-0"
                            @click="setDisplay('list')">
                        <AlignCenterIcon v-if="display === 'list'"
                                         size="1.5x"
                                         stroke-width="2" />
                        <AlignCenterIcon v-else
                                         size="1.5x"
                                         stroke-width="2"
                                         class="lightcolor" />
                    </button>
                </div>
            </div>
        </div>
        <!-- 文章資料 -->
        <ArticleDisplay :display="display"
                        :contentPage="contentPage"
                        :articleRes="articleRes"
                        :isShowOrderNum="false"
                        :loading="loading" />
        <Pagination :lastPage="lastPage"
                    :gaData="`${gaData}${categories}|`"
                    :currentPage="currentPage"
                    @getPage="getPage" />
    </div>
</template>
<script>
import { post } from '@/api';
import { AlignCenterIcon, GridIcon } from 'vue-feather-icons';
import Theme from '@/components/Theme.vue';
import BreadCrumbs from '@/components/BreadCrumbs.vue';
import ArticleDisplay from './ArticleDisplay.vue';
import Pagination from '@/components/Pagination.vue';

export default {
    name: 'CategoriesArticleList',
    components: {
        Theme,
        AlignCenterIcon,
        GridIcon,
        ArticleDisplay,
        Pagination,
        BreadCrumbs,
    },
    data() {
        return {
            contentPage: '分類',
            spaceName: '文章列表',
            total: 0,
            loading: false,
            inputText: '',
            currentPage: 0,
            lastPage: 0,
            orderby: {
                value: 'relation',
                label: '最相關',
            },
            type: {
                value: 'all',
                label: '全部',
            },
            menuList: this.$store.state.menuList,
            menu: {},
            orderbyList: [
                {
                    value: 'relation',
                    label: '最相關',
                },
                {
                    value: 'hot',
                    label: '最熱門',
                },
                {
                    value: 'new',
                    label: '新到舊',
                },
                {
                    value: 'old',
                    label: '舊到新',
                },
            ],
            typeList: [
                {
                    value: 'all',
                    label: '全部',
                },
                {
                    value: 'vedio',
                    label: '影片',
                },
                {
                    value: 'picture',
                    label: '圖片',
                },
                {
                    value: 'article',
                    label: '文章',
                },
                {
                    value: 'web',
                    label: '互動網頁',
                },
            ],
            articleRes: [
            ],
            categories: '',
            display: 'card',
            column: '',
            value: '',
            breadCrumbList: [],
        };
    },
    watch: {
        '$route.params.categories': {
            handler: function(newValue, oldValue) {
                this.categories = this.$route.params.categories;
                if (newValue !== oldValue && oldValue) {
                    this.setbreadCrumbList();
                }
            },
            deep: true,
            immediate: true
        },
        '$route.params.page': {
            handler: function(newValue, oldValue) {
                this.currentPage = Number(this.$route.params.page);
                if (newValue !== oldValue && oldValue) {
                    this.getArticleList();
                }
            },
            deep: true,
            immediate: true
        },
    },
    created() {
        this.display = this.$store.state.displayArticles;
        this.setbreadCrumbList();
    },
    computed: {
        gaData() {
            return `${this.systemName}|${this.contentPage}${this.spaceName}|`;
        },
    },
    methods: {
        setbreadCrumbList() {
            const bread = [];
            this.column = '';
            this.value = '';
            let j = 0;
            while (j < this.menuList.length && this.column === '') {
                const { label, value, children } = this.menuList[j];
                if (label === this.categories) {
                    const json = {
                        name: label,
                        link: '',
                        gastr: label,
                    };
                    this.column = 'firstContentCategory';
                    this.value = value;
                    bread.push(json);
                } else {
                    const child = children.find((i) => {
                        return i.label === this.categories;
                    });
                    if (child) {
                        const parent = {
                            name: label,
                            link: { name: 'categories', params: { page: 1, categories: label } },
                            gastr: label,
                        };
                        const kid = {
                            name: child.label,
                            link: '',
                            gastr: child.label,
                        };
                        this.value = child.value;
                        bread.push(parent, kid);
                        this.column = 'secondContentCategory';
                    } else {
                        j++;
                    }
                }
            }
            if (bread.length > 0) {
                this.breadCrumbList = bread;
                this.getArticleList();
            } else {
                this.go404Page(404);
            }
        },
        getArticleList() {
            this.loading = true;
            const pg = Number(this.$route.params.page);
            if (pg < 1 || !pg) {
                this.routerTo(1);
                return;
            }
            this.articleRes = [];
            this.total = 0;
            this.lastPage = 0;
            const data = {
                conditions: [
                    {
                        column: this.column,
                        value: this.value,
                        operator: 'eq',
                    },
                    {
                        column: 'state',
                        value: 'ON',
                        operator: 'eq'
                    }
                ],
                sortBy: ['onDate'],
                sortDesc: [true],
                size: this.size,
                page: pg - 1,
            };
            post('/api/content/list', data)
                .then((res) => {
                    if (res.status === 200) {
                        const result = res.response;
                        if (result.contents.length > 0) {
                            this.articleRes = result.contents;
                            this.total = result.total;
                            this.lastPage = Math.ceil(this.total / result.size);
                        }
                    }
                })
                .catch((error) => {
                    this.go404Page(error.status);
                }).finally(() => {
                    this.loading = false;
                });
        },
        setOrderby(value) {
            this.orderby = Object.assign(value);
        },
        setType(value) {
            this.type = Object.assign(value);
        },
        setDisplay(type) {
            this.setDisplayArticles(type);
        },
        getPage(value) {
            this.routerTo(value);
        },
        routerTo(pg) {
            this.$router.push({ name: 'categories', params: { page: pg, categories: this.categories } }).catch(() => { });
        },
    },
};
</script>
<style lang="scss" scoped>
.itemList {
    .lightcolor {
        color: #d5d5d5;
    }
}
.listType {
    position: absolute;
    top: -2.2rem;
    right: 0;
    @include media-breakpoint-up(md) {
        top: -3.5rem;
    }
    @include media-breakpoint-up(lg) {
        margin-top: 0;
        top: 0;
        position: relative;
    }
}
.moreItem__btn {
    position: relative;
    max-width: 24rem;
}
</style>
